module.exports = __webpack_public_path__ + "img/3.b7fb1aed.png";